import React, { type ReactElement } from 'react';
import {
	ConfluenceDataCenterIcon,
	ConfluenceIcon,
	JiraDataCenterIcon,
	JiraIcon,
} from '@atlaskit/logo';
import { Text } from '@atlaskit/primitives/compiled';
import type { ApplicationLinkV3Data } from './entities.tsx';

export type TypeDefinition = {
	name: string;
	icon: ReactElement;
};

export type TypeLookup = { [key: string]: TypeDefinition };

// TODO: Better way of handling Cloud/DC split
export const TypeIdMap: TypeLookup = {
	jira: {
		name: 'Jira',
		icon: <JiraIcon shouldUseNewLogoDesign label="Jira" />,
	},
	'jira-dc': {
		name: 'Jira DC',
		icon: <JiraDataCenterIcon shouldUseNewLogoDesign label="Jira Data Center" />,
	},
	confluence: {
		name: 'Confluence',
		icon: <ConfluenceIcon shouldUseNewLogoDesign label="Confluence" />,
	},
	'confluence-dc': {
		name: 'Confluence DC',
		icon: <ConfluenceDataCenterIcon shouldUseNewLogoDesign label="Confluence Data Center" />,
	},
};

export const lookupType = (dcAwareTypeId: string): TypeDefinition => {
	return (
		TypeIdMap[dcAwareTypeId] || {
			name: 'Unknown',
			icon: <Text>Unknown</Text>,
		}
	);
};

export const lookupTypeByTypeId = (typeid: string, isDataCenter: boolean): TypeDefinition => {
	return lookupType(`${typeid}${isDataCenter ? '-dc' : ''}`);
};

export const lookupTypeFromV3Data = (link: ApplicationLinkV3Data): TypeDefinition => {
	const type = link.type;
	// TODO: We can determine if it's DC, but how?
	// if (link.data.applicationVersion !== undefined) {
	// 	type += '-dc';
	// }

	return lookupTypeByTypeId(type, false);
};
